import React from 'react';

const ArrowIcon = ({ className }) => (
  <svg className={className} width="70" height="52" viewBox="0 0 70 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M65.5 26H4.5M65.5 26L44 4.5M65.5 26L44 47.5" stroke="white" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default ArrowIcon;